import { render, staticRenderFns } from "./ObjectPersonRuleForm.vue?vue&type=template&id=39090012&"
import script from "./ObjectPersonRuleForm.vue?vue&type=script&lang=js&"
export * from "./ObjectPersonRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./ObjectPersonRuleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports